<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m32.95,29.67c-1.37,0-2.5-1.1-2.52-2.48-.02-1.39,1.09-2.54,2.48-2.56l39.5-.57c1.39,0,2.54,1.09,2.56,2.48.02,1.39-1.09,2.54-2.48,2.56l-39.5.57h-.04Z"/>
  <g>
    <circle class="cls-1" cx="72.46" cy="26.58" r="5.75"/>
    <path class="cls-3" d="m72.47,34.43c-.54,0-1.08-.06-1.61-.17-2.05-.43-3.82-1.63-4.97-3.38-2.37-3.62-1.36-8.49,2.26-10.87,1.75-1.15,3.85-1.55,5.9-1.12,2.05.43,3.82,1.63,4.97,3.38,2.37,3.62,1.36,8.49-2.26,10.87-1.29.85-2.78,1.29-4.29,1.29Zm-.02-11.5c-.7,0-1.39.2-1.99.6-1.68,1.1-2.15,3.37-1.05,5.05.53.81,1.35,1.37,2.31,1.57.95.2,1.93.01,2.74-.52,1.68-1.1,2.15-3.37,1.05-5.05-.53-.81-1.35-1.37-2.31-1.57-.25-.05-.5-.08-.75-.08Z"/>
  </g>
  <path class="cls-2" d="m17.61,65.79c-.33,0-.66-.06-.98-.2-1.28-.54-1.88-2.02-1.34-3.3l15.34-36.41c.54-1.28,2.02-1.88,3.3-1.34,1.28.54,1.88,2.02,1.34,3.3l-15.34,36.41c-.41.96-1.34,1.54-2.32,1.54Z"/>
  <g>
    <circle class="cls-1" cx="17.55" cy="63.42" r="5.75"/>
    <path class="cls-3" d="m17.55,71.27c-1.03,0-2.07-.21-3.05-.62-1.93-.81-3.43-2.33-4.22-4.27-.79-1.94-.78-4.08.04-6.01,1.68-3.99,6.29-5.87,10.28-4.18h0c1.93.81,3.43,2.33,4.22,4.27s.78,4.07-.04,6.01c-.81,1.93-2.33,3.43-4.27,4.22-.96.39-1.96.58-2.96.58Zm0-11.5c-1.42,0-2.78.84-3.37,2.23-.38.9-.38,1.89-.02,2.79.37.9,1.06,1.61,1.96,1.99.9.38,1.89.38,2.79.02s1.61-1.06,1.99-1.96.38-1.89.02-2.79c-.37-.9-1.06-1.61-1.96-1.99-.46-.19-.94-.29-1.41-.29Z"/>
  </g>
  <g>
    <circle class="cls-1" cx="32.96" cy="26.86" r="5.75"/>
    <path class="cls-3" d="m32.95,34.72c-1.03,0-2.07-.21-3.05-.62-1.93-.81-3.43-2.33-4.22-4.27-.79-1.94-.78-4.07.04-6.01,1.68-3.99,6.29-5.87,10.28-4.18,1.93.81,3.43,2.33,4.22,4.27s.78,4.07-.04,6.01c-.81,1.93-2.33,3.43-4.27,4.22-.96.39-1.96.58-2.96.58Zm0-11.5c-.47,0-.93.09-1.38.27-.9.37-1.61,1.06-1.99,1.96-.38.9-.38,1.89-.02,2.79.37.9,1.06,1.61,1.96,1.99.9.38,1.89.38,2.79.02.9-.37,1.61-1.06,1.99-1.96s.38-1.89.02-2.79c-.37-.9-1.06-1.61-1.96-1.99h0c-.46-.19-.94-.29-1.42-.29Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "SegmentShareIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #116577;
  }
</style>